import * as _4 from 'lodash4';
import { IMajorCareer } from '../../major_explorer_interface';

export class MajorTileCareersListController {
  private careerList: IMajorCareer[];

  containsNoCareerData(): boolean {
    return (
      _4.isEmpty(_4.get(this.careerList, 'allCareers', {})) &&
      !_4.isUndefined(_4.get(this.careerList, 'allCareers', {}))
    );
  }
}

export class MajorTileCareersListComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_tile_careers_list/major_tile_careers_list.html';
  public controller: any = MajorTileCareersListController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    careerList: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_tile_careers_list/major_tile_careers_list_controller.ts